import React from 'react';
import { useState } from 'react';
import { Dimensions } from 'react-native';
import { designConstants } from '../styles';
import { trackButtonPress } from '../../shared/utilities/gatracker';
import CollapsibleCardContainer from './CollapsibleCardContainer';
import NonCollapsibleCardContainer from './NonCollapsibleCardContainer';

// Since the Card should be full-wide width, the width is fixed, and all correspondent widths are accessible via
// static props, it is needed e.g. for graphs WebView width calculation
const CARD_MARGIN = 8;
const CARD_PADDING = 20;
const getCardContainerWidth = () => {
  let width = Dimensions.get('window').width;
  return width - 2 * 8;
};
const getCardContentWidth = () => {
  if (designConstants.isWeb) {
    return 500;
  }
  let width = Dimensions.get('window').width;
  return width - 2 * 8 - 2 * 20;
};
const CARD_MIN_WIDTH = 300;

export {
  getCardContainerWidth,
  getCardContentWidth,
  CARD_MARGIN,
  CARD_PADDING,
  CARD_MIN_WIDTH,
};

export default function CardItemWide(props) {
  const { title, isCollapsible, type } = props;
  const [width, setWidth] = useState(getCardContainerWidth());

  const onPress = () => {
    const { onBottomButtonPress } = props;
    title && trackButtonPress('Card bottom ' + title);
    onBottomButtonPress && onBottomButtonPress();
  };

  const onLayout = (e) => {
    if (props.onLayout) {
      props.onLayout(e);
    }

    let newWidth = e.nativeEvent.layout.width;
    let currentWidth = width;
    if (newWidth !== currentWidth) {
      setWidth(newWidth);
    }
  };

  if (isCollapsible) {
    return (
      <CollapsibleCardContainer
        onLayout={onLayout}
        onBottomButtonPress={onPress}
        type={type}
        {...props}
      />
    );
  }

  return (
    <NonCollapsibleCardContainer
      onLayout={onLayout}
      onBottomButtonPress={onPress}
      {...props}
    />
  );
}
